<template>
  <section class="landing-banner-section">
    <b-container class="landing-banner-wrapper">
      <b-row>
        <b-col>
          <h1 class="heading">Boost your school learning</h1>
          <div class="details">
            Online live courses from the India's leading experts. join the best
            live learning platform today
          </div>
          <div class="button-rack">
            <b-button
              size="lg"
              pill
              variant="secondary"
              @click="goToAllCourses"
            >
              <span>Find your course</span>
              <font-awesome-icon icon="arrow-right" size="xs" />
            </b-button>
            <b-button size="lg" pill variant="primary" @click="goToLogin">
              <span>Login now</span>
              <font-awesome-icon icon="arrow-right" size="xs" />
            </b-button>
          </div>
          <feature-list-template></feature-list-template>
        </b-col>
        <b-col>
          <div class="landing-illustration-wrapper">
            <b-img
              src="../../../static/images/home-page-illustration.png"
              fluid
              alt="Working image"
            ></b-img>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import featureListTemplate from "../Templates/FeatureListTemplate";

export default {
  name: "landing_banner",
  components: {
    featureListTemplate: featureListTemplate
  },
  methods: {
    goToLogin() {
      this.$bvModal.show("modal-1");
    },
    goToAllCourses() {
      this.$router.push({
        path: "/all_courses"
      });
    }
  }
};
</script>

<style></style>
